import BFormItem from '../Form/packages/BFormItem'

BFormItem.install = function(Vue) {
    Vue.component(BFormItem.name, BFormItem)
}

export default BFormItem
